import Vue from 'vue'
import Vuex from 'vuex'
import state from '~store/state'
import getters from '~store/getters'
import mutations from '~store/mutations'
import actions from '~store/actions'
import lawsuitsModule from '~store/modules/lawsuits/store'
import notificationsModule from '~store/modules/notifications/store'
import projectsModule from '~store/modules/projects/store'
import authModule from '~store/modules/auth/store'
import loadingModule from '~store/modules/loading/store'
import dynamicModule from '~store/modules/dynamic/store'
import documentsModule from '~store/modules/documents/store'
import dashboardsModule from '~store/modules/dashboards/store'
import usersModule from '~store/modules/users/store'
import dataModule from '~store/modules/data/store'
import paymentsModule from '~store/modules/payments/store'
import jobsModule from '~store/modules/jobs/store'
import organizationsModule from '~store/modules/organizations/store'
import contractsModule from '~store/modules/contracts/store'
import referralsModule from '~store/modules/referrals/store'
import financeModule from '~store/modules/finance/store'
import servicesModule from '~store/modules/services/store'
import invoicesModule from '~store/modules/invoices/store'
import onboardingModule from '~store/modules/onboarding/store'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    lawsuitsModule,
    notificationsModule,
    projectsModule,
    authModule,
    loadingModule,
    dynamicModule,
    documentsModule,
    dashboardsModule,
    usersModule,
    dataModule,
    paymentsModule,
    jobsModule,
    organizationsModule,
    contractsModule,
    referralsModule,
    financeModule,
    servicesModule,
    invoicesModule,
    onboardingModule
  },
  state,
  getters,
  mutations,
  actions
})

const initialStateCopy = JSON.parse(JSON.stringify(store.state))

store.resetState = () => {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)))
}

export default store
